import { config } from '../config'
import { application } from '../constants'
import { setupPayPalAnalytics } from './setup-paypal-analytics'
/**
 * Load PayPal Analytics (FPTI).
 * @param {String} fptiData Setup fpti with data provided by fptiSetup.js and modify from there
 */
export function loadPayPalAnalytics(fptiData) {
  // check if FPTI script has been loaded
  const script = config.fpti.script[application.env]
  const existingScripts = document.querySelectorAll('script')
  let isPALoaded = false
  for (let i = 0; i < existingScripts.length; i++) {
    if (existingScripts[i].getAttribute('src') === script) {
      isPALoaded = true
      break
    }
  }

  if (!isPALoaded) {
    let ppa = document.createElement('script')

    ppa.src = script
    //ppa.src = application.env === 'prod' ? `https://${instanceLocation.getCdnHostName()}/pa/js/min/pa.js` : `https://${instanceLocation.getCdnHostName()}/staging/pa/js/min/pa.js`

    // Add FPTI script to page.
    document.body.appendChild(ppa)

    // Wait for script to load before proceeding.
    ppa.addEventListener('load', function () {
      isPALoaded = true
      setupPayPalAnalytics(fptiData)

      // Fire an event that pa.js has loaded, which will allow us to react to
      // it, like we're doing for `cust` property in <Provider />
      isPALoaded = true
      const event = new Event('paLoaded')
      window.dispatchEvent(event)
    })
  } else {
    setupPayPalAnalytics(fptiData)
  }
}
